<template>
  <DialogLayout class="flow-configure-form-setting"
                :title="getTitle"
                v-loading="loading"
                element-loading-text="数据加载中，请稍等...">
    <template v-if="settingInfo">
      <div class="setting-main"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <FlowConfigureSetting :setting-info="settingInfo"
                              @status-changed="onStatusChanged"
                              @remove-item="onRemoveItem"
                              @remove-all="onRemoveAll"></FlowConfigureSetting>
      </div>
    </template>
    <template v-else-if="!loading">
      <Hint type="error">
        <div>流程配置数据加载失败</div>
        <el-button size="mini" type="text" @click="loadSettingInfo">重新加载</el-button>
      </Hint>
    </template>
  </DialogLayout>
</template>

<script>
import DialogLayout from '../../../../widgets/DialogLayout'
import FlowConfigureSetting from '../setting'
import Hint from '../../../../elements/Hint'
import { getValueByPath } from 'element-ui/lib/utils/util'
export default {
  name: 'FlowConfigureFormSetting',
  components: {
    DialogLayout,
    FlowConfigureSetting,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      settingInfo: null,
      committing: false
    }
  },
  computed: {
    getTitle () {
      return `表单审批设置 - ${getValueByPath(this.rowData, 'name')} [${getValueByPath(this.rowData, 'catalogName')}] `
    }
  },
  methods: {
    loadSettingInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/flow/configure/form/settingInfo',
        method: 'post',
        data: this.$qs.stringify({
          flowId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.settingInfo = response.data.settingInfo || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    onStatusChanged () {
      this.loadSettingInfo()
      this.$nextTick(() => {
        this.$emit('reloadGridData')
      })
    },
    onRemoveItem ({ recordId, forceDelete }) {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/flow/configure/form/removeDefinition',
        method: 'post',
        data: this.$qs.stringify({
          flowId: this.rowData.id,
          recordId: recordId,
          forceDelete: forceDelete
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'] || '删除成功')
              this.loadSettingInfo()
              this.$nextTick(() => {
                this.$emit('reloadGridData')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    onRemoveAll ({ forceDelete }) {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/flow/configure/form/removeAll',
        method: 'post',
        data: this.$qs.stringify({
          flowId: this.rowData.id,
          forceDelete: forceDelete
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'] || '清除成功')
              this.loadSettingInfo()
              this.$nextTick(() => {
                this.$emit('reloadGridData')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  mounted () {
    this.loadSettingInfo()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadSettingInfo()
      }
    }
  }
}
</script>

<style lang="scss">
.flow-configure-form-setting {
  width: 700px;
  max-width: 100%;
  height: 100%;
  .setting-main {
    height: 100%;
  }
}
</style>
